import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { useSelector } from 'react-redux';

import BoardPodiums from './BoardPodiums';
import BoardTableWrapper from './BoardTableWrapper';

import Title from '../../../shared/_TBComponents/Title';
import { MINIMIZED_BREAKPOINT } from '../boardConstants';

const BlankBoardContainer = styled('div')`
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;
`;

const BoardData = ({
  activeBoards,
  boardWidth,
  id,
  scaleFactor,
}) => {
  const leaderboardData = useSelector(
    (state) => state.leaderboard.data.leaderboards[id].leaderboardData,
  );
  const leaderboardForm = useSelector(
    (state) => state.leaderboard.data.leaderboards[id].leaderboardForm,
  );

  return (
    leaderboardData.length !== 0 ? (
      <>
        <BoardPodiums
          activeBoards={activeBoards}
          boardWidth={boardWidth}
          leaderboardData={leaderboardData}
          scaleFactor={scaleFactor}
          showChange={leaderboardForm.compareTo !== 0 && boardWidth > MINIMIZED_BREAKPOINT}
        />
        <BoardTableWrapper
          boardWidth={boardWidth}
          id={id}
          scaleFactor={scaleFactor}
        />
      </>
    ) : (
      <BlankBoardContainer>
        <Title
          icon='trophy'
        >
          No Records Found
        </Title>
      </BlankBoardContainer>
    )
  );
};

BoardData.propTypes = {
  activeBoards: PropTypes.number.isRequired,
  boardWidth: PropTypes.number.isRequired,
  id: PropTypes.number.isRequired,
  scaleFactor: PropTypes.number.isRequired,
};

export default BoardData;
